module.exports = __webpack_public_path__ + "static/media/argumentTeam.81d6729a.svg";